// 设置CSS变量：--vh， 以实现移动端100vh的支持
export function setVariableVH() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
